




































































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiPartenaire from '@/api/partenaire'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { getDefaultAloMeta } from '@/models/alo/AloMeta'
import * as rules from '@/utils/validationRules'
//@ts-ignore
import VJsoneditor from 'v-jsoneditor/src/index'
import { ExportCatalogType } from '@/enum/ExportCatalogType'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ModifyMetas', 
  props: {
    mtaId:Number
  },
  components: { CheckState,VJsoneditor},
})

export default class ModifyMetas extends Vue {
  mtaId!: number
  private showError = false    
  private loading = false
  private saving = false
  private modified = getDefaultAloMeta()

  get meta(){
    return this.$store.myGetters.metas[this.mtaId] || getDefaultAloMeta()
  }

  get ExportCatalogType() {
    return ExportCatalogType
  }

  get dataSourcesList(){
    return this.$store.myGetters.dataSourcesList
  }

  get enseignesList(){
    return this.$store.myGetters.enseignesList
  }

  get metaGroupsList() {
    return this.$store.myGetters.metaGroupsList
  }

  get json(){
    return JSON.parse(this.modified.mtaConfigJson)
  }

  set json(newValue){
    this.modified.mtaConfigJson = JSON.stringify(newValue)
  }

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  loadMeta() {       
    if(this.mtaId != 0) {
      this.loading = true
      this.$store.myActions.CATALOGUE_META_DETAIL_REQUEST(this.mtaId).then((meta) =>{
        this.modified = {...getDefaultAloMeta(), ...cloneDeep(meta)}
      })
      .finally(() => {        
        this.loading = false
      })    
    }
  }

  get isDirty() {
    return !deepEqual(this.meta,this.modified)
  }

  created(){
    this.$store.myActions.ADM_DATASOURCE_ENSURE()
    this.loadMeta()
  }

  get arianeItems() {
    const arianeItems =  [
        {
          text: 'Data sources',
          disabled: false,          
          to: "/admin/metas",
          exact:true
        }
      ]
    if(this.meta) {
        arianeItems.push({
          text: this.meta.libelle,
          disabled: true,          
          to: "",
          exact:true
        })
    }
    return arianeItems;
  } 

  get metasStatus() {
    return this.$store.myGetters.metasStatus        
  }
  

  saveData() {
    if ((this.$refs.editMetaForm as HTMLFormElement).validate()) {
      this.saving = true       
      const redirect = this.modified.id != this.modified.newId
      this.$store.myActions.CATALOGUE_META_SAVE_REQUEST(this.modified).then((savedSataSource:any) => {
        this.modified = cloneDeep(savedSataSource)
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.metasStatus)                  
        if(redirect) this.$router.push({name:'ModifyMetas',params:{mtaId:savedSataSource.id}})        
      }).finally(()=> {
        this.saving = false
      })    
    }
  }

  deleteMeta(){
    if(this.mtaId != 0) {      
       this.$confirm("Voulez vous vraiment supprimer ce meta?",{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.CATALOGUE_META_DELETE_REQUEST(this.mtaId).then(() => {
            this.$router.push({name:'Metas'})
          })
        } 
      })          
    } 
  }

  cancelDataSource(){
    if(this.mtaId == 0) this.modified = getDefaultAloMeta()
    else this.loadMeta()
  }

}
